import React, {useState} from 'react';
import './ScheduleVersionsModal.scss';
import i18next from "i18next";
import GeneralModal from "../../Modals/GeneralModal/GeneralModal";
import LabeledDropdown from "../../Custom UI/LabeledInputs/LabeledDropDown/LabeledDropDown";
import {momentFromDateTime} from "../../Helpers/DateHelpers";
import {formatUserName} from "../../Helpers/AdminHelpers";
import {optionForScheduleVersion} from "../../Helpers/ScheduleHistoryHelpers";

const ScheduleVersionsModal = ({open, close, selectScheduleVersion, presentedInsideParentModal, fetchScheduleVersionsForSchedule}) => {
  
  // Instance Variables
  
  const [selectedVersion, setSelectedVersion] = useState(null);
  
  // Render
  
  return (
    <GeneralModal title={i18next.t('HISTORY')}
                  description={i18next.t('SCHEDULE_HISTORY_DESCRIPTION')}
                  width={'520px'}
                  height={'280px'}
                  isOpen={open}
                  maxWidth={520}
                  maxHeight={280}
                  handleSave={() => {
                    if(selectedVersion){
                      selectScheduleVersion(selectedVersion);
                      setSelectedVersion(null);
                    }
                  }}
                  noTitleHeading={true}
                  showSaveButton={selectedVersion !== null}
                  containsDropDown={true}
                  handleCloseModal={() => {
                    close();
                    setSelectedVersion(null);
                  }}
                  maxChildrenHeight={180}
                  presentedInsideParentModal={presentedInsideParentModal}>
      {open ?
        <LabeledDropdown className="schedule-versions-modal-dropdown"
                       value={selectedVersion}
                       handleSave={(aVersion) => setSelectedVersion(aVersion)}
                       placeholder={i18next.t('SEARCH_SCHEDULE_HISTORY')}
                       fetchObjects={(aLimit, aOffset) => fetchScheduleVersionsForSchedule(aLimit, aOffset)}
                       labelPropertiesArray={['name']}
                       valuePropertiesArray={['id']}
                       optionsArrayFormatter={(aArray) => {
                         let optionsArray = [];
    
                         for(let scheduleVersion of aArray){
                           optionsArray.push(optionForScheduleVersion(scheduleVersion, i18next.t.bind(i18next), momentFromDateTime, formatUserName));
                         }
                         return optionsArray;
                       }}
                       responseTotalKeysArray={['data', 'data', 'schedule_versions', 'total']}
                       responseObjectKeysArray={['data', 'data', 'schedule_versions', 'schedule_versions']}
        />
        : null
      }
    </GeneralModal>
  );
};

export default ScheduleVersionsModal
